export default __webpack_public_path__ + "static/cafe_36076-cef5a4df3667e1b369123aec2974cfef.png";